import { render, staticRenderFns } from "./ItemQuery.vue?vue&type=template&id=956a3376&"
import script from "./ItemQuery.vue?vue&type=script&lang=js&"
export * from "./ItemQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports